module.exports = __webpack_public_path__ + "Server-Default-AzureServiceFabricCluster.85961263a9c5398af430cca421828d35.hashedasset.svg";